import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpService } from '@services/index';
import { EndpointParams } from '@models/utils/endpoint-params';
import { PayerAuthenticationSetup } from '@models/payerauthentication/payerauthentication-setup';
import { PayerAuthenticationEnrollment, PayerAuthenticationEnrollmentResponse, PayerAuthenticationSetupResponse } from '@models/index';

@Injectable()
export class PayerAuthenticationService extends HttpService {
    private readonly defaultEndpointParams: EndpointParams = { app: 'payments', version: 1 };

    setup(dto: PayerAuthenticationSetup): Observable<PayerAuthenticationSetupResponse> {
        return this.post('payer-authentication/member/setup', this.defaultEndpointParams, dto);
    }

    enrollment(dto: PayerAuthenticationEnrollment): Observable<PayerAuthenticationEnrollmentResponse> {
        return this.post('payer-authentication/member/enrollment', this.defaultEndpointParams, dto);
    }
}
